import { type ExportType } from '@components'

import { useCallback } from 'react'

import { useSegment } from '../../../hooks'

interface TrackProductsExportParams {
  fileFormat: ExportType
  itemCount?: number
}

export const useTrackProductsExport = () => {
  const { track } = useSegment()

  const trackProductsExport = useCallback(
    (params: TrackProductsExportParams) => {
      const { fileFormat, itemCount } = params

      track('Item List Exported (Client)', {
        fileFormat,
        ...(itemCount === undefined ? {} : { itemCount }),
      })

      /* eslint-disable @typescript-eslint/naming-convention -- Segment exports event properties are snake_case */
      track('XXX - Mikkel - Exports', {
        export_type: 'Products',
        file_format: fileFormat,
      })
      /* eslint-enable @typescript-eslint/naming-convention */
    },
    [track],
  )

  return { trackProductsExport }
}
